import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-condicion-contable',
  templateUrl: './btn-nuevo-tipo-condicion-contable.component.html',
  styleUrls: ['./btn-nuevo-tipo-condicion-contable.component.css']
})
export class BtnNuevoTipoCondicionContableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
